import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Img from "gatsby-image"

import Banner from '../components/banner'
import ImgPara from '../components/layouts/img-para'
import Layout from '../components/layouts/mainLayout'

import Head from '../components/head'


const JimLawson = () => {

    const data = useStaticQuery(graphql`
        query{
            contentfulJimLawsonMemorial{
                memorial {
                    json
               }
            }
            BannerImg: file(relativePath: {eq:"JimLawson.jpg"}){
                ...FluidImageFragment
            }
            JimLawson: file(relativePath: {eq:"JimCollage.jpg"}){
                childImageSharp { 
                    fluid(grayscale: true) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
        }      
    `)

    return (
        <div>
            <Layout>
                <Head title="Jim Lawson"/>
                <Banner 
                    title="JIM LAWSON" 
                    img={data.BannerImg.childImageSharp.fluid}
                    height="small"
                />
                <div className="container max">
                    <ImgPara>
                        <div className="info span3">
                            {documentToReactComponents(data.contentfulJimLawsonMemorial.memorial.json)}
                        </div>
                        <div className="img-container span3">
                            <Img fluid={data.JimLawson.childImageSharp.fluid} alt="Jim Lawson" />
                        </div>
                    </ImgPara>
                </div>    
            </Layout>
        </div>
    )
}

export default JimLawson
